import React from 'react'
import Assets from 'app/configs/assetConfigs'
import { FormattedMessage } from 'react-intl'
import * as R from 'ramda'
import MessageBadge from './MessageBadge'
import { TYPE_EVENT, TYPE_POLL } from 'app/constants/messageType'
import { PollTypeIcon } from 'app/components/icons'

const badgePropsForType = R.cond([
  [
    R.equals(TYPE_EVENT),
    R.always({
      variant: 'primary',
      Icon: <img src={Assets.notiTypeInPreview.event} alt="event" />,
      children: <FormattedMessage id="notiType.event.label" />,
    }),
  ],
  [
    R.equals(TYPE_POLL),
    R.always({
      variant: 'primary',
      children: <FormattedMessage id="notification.type.poll" />,
    }),
  ],
  [
    R.T,
    R.always({
      variant: 'primary',
      Icon: <img src={Assets.notiTypeInPreview.info} alt="general" />,
      children: <FormattedMessage id="notiType.general.label" />,
    }),
  ],
])

const MessageTypeChip = ({ type, className }) => {
  return (
    <MessageBadge
      className={className}
      isTextUpperCase={false}
      type={type}
      {...badgePropsForType(type)}
    />
  )
}

export default MessageTypeChip
